export async function getList() {
  return this.$frontendRepositories.plan.getValidPlans()
}

export async function updatePaymentStep({ dispatch }, payload) {
  const { errResponse } = await this.$frontendRepositories.plan.updatePaymentStep(payload)

  if (errResponse) {
    return Promise.reject()
  }

  dispatch('frontend/auth/updatePaymentStep', { root: true })
  return Promise.resolve()
}

export async function getUsers() {
  return this.$frontendRepositories.plan.getUsers()
}

export async function changePlan(_, payload) {
  return this.$frontendRepositories.plan.changePlan(payload)
}

export async function getCurrentPlanWhenPayment() {
  return this.$frontendRepositories.plan.getCurrentPlanWhenPayment()
}

export async function checkExpired() {
  return this.$frontendRepositories.plan.checkExpired()
}

export async function checkLimit() {
  return this.$frontendRepositories.plan.checkLimit()
}

export async function getTransactionHistory() {
  return this.$frontendRepositories.plan.getTransactionHistory()
}

export async function generateBill(_, invoiceId) {
  return this.$frontendRepositories.plan.generateBill(invoiceId)
}